import axios from 'axios';

export function getStores() {
    return new Promise((resolve, reject) => {
        axios.get('/web/stores')
            .then(response => {                
                resolve(response.data);       
            })
            .catch(error => {
                reject(error);
            });
    })
}

export function getStockInStores(items) {
    var barcodes = {};
    items.forEach((item) => {
        barcodes[item.barcode] = item.units;
    });
    var result = {}
    result = { 'barcodes': barcodes };
    return new Promise((resolve, reject) => {
        axios.post('/web/stores/stock', result)
        .then(response => {            
            resolve(response.data);
        })
        .catch(error => {
            console.error('Error en la solicitud a /web/store:', error);
            reject(error);
        });
    })
}

// tienda mas cercana con carrito del cx
export function nearestStoreWithTicket(customerLocation, items) {
    var barcode = {};
    items.forEach((item) => {
        barcode[item.barcode] = item.units;
    });
    return new Promise((resolve, reject) => {
        axios.post('/web/stores/nearest', {customerLocation, barcode})
        .then(response => {                
            resolve(response.data);
        })
        .catch(error => {
            console.error('Error en la solicitud a /web/store:', error);
            reject(error);
        });
    })
}

export default {
    getStores,
    getStockInStores
}
